import { Link, useNavigate } from 'react-router';
import { Button } from '@/components/Button';
import { useAuth } from '@/contexts/auth';
import { LeftNav } from './LeftNav';

export function Navbar() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  function handleSignOut() {
    void signOut().then(() => {
      void navigate('/sign-in');
    });
  }

  return (
    <nav className="relative z-10 px-5 shadow-sm">
      <div className="flex justify-between py-2">
        {user && <LeftNav />}
        <div className="flex flex-1 items-center justify-end">
          {user ? (
            <div className="flex items-center space-x-4">
              <Button variant="outline" size="sm" onClick={handleSignOut}>
                Sign Out
              </Button>
            </div>
          ) : (
            <div>
              <div className="flex items-center space-x-4">
                <Link to="/sign-in">
                  <Button variant="outline" size="sm">
                    Sign In
                  </Button>
                </Link>
                <Link to="/sign-up">
                  <Button size="sm">Sign Up</Button>
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
